"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function Carousel(props) {
  var children = props.children,
      _a = props.render,
      render = _a === void 0 ? null : _a,
      indexClass = props.indexClass,
      autoPlay = props.autoPlay,
      _b = props.delay,
      delay = _b === void 0 ? 0 : _b,
      _c = props.onChange,
      onChange = _c === void 0 ? null : _c,
      _d = props.accordant,
      accordant = _d === void 0 ? false : _d; // console.log(children)

  var sliderListRef = (0, _react.useRef)(null);
  var parentRef = (0, _react.useRef)(null);
  var sliderProcess = (0, _react.useRef)(null);
  var requestFunc;
  var distance = {
    start_x: 0,
    start_y: 0,
    x: 0,
    y: 0,
    current_x: 0,
    strength: 0,
    len: 0,
    fullPageAttachMove: 990,
    fullPageLast: 660,
    fullPageMove: 330,
    fullMove_direction: 0,
    mouseX: 0,
    targetX: 0,
    easing: 0.2,
    moving: 0,
    yd: 10,
    preYd: 10,
    play: true,
    autoPlay: [0, 0],
    left: false,
    right: false,
    index: 0,
    tempSliderProcess: null,
    sliderProcess: null,
    snapshoot: 0,
    lockStatus: false
  };

  var animation = function animation(sliderListRef) {
    var _a, _b, _c, _d, _e, _f;

    distance.moving = distance.x;

    if (Math.abs(distance.targetX - distance.x) < 1) {
      distance.x = distance.targetX;
    } else {
      distance.x += (distance.targetX - distance.x) * 0.2;
    } // ball.y += (targetY - ball.y) * distance.easing;
    // 目前判断是否点击操作distance.preYd !== distance.yd


    if (sliderListRef.current && (distance.autoPlay[0] === 0 || distance.preYd !== distance.yd)) {
      sliderListRef.current.style.transform = "translate3d(" + Math.ceil(distance.x) + "px, 0, 0)";
    }

    if (Math.floor(distance.moving) % distance.fullPageMove !== 0 && Math.ceil(distance.moving) % distance.fullPageMove !== 0) {
      requestAnimationFrame(function () {
        animation(sliderListRef);
      });
    } else {
      // 目前判断是否点击操作distance.preYd !== distance.yd
      if (distance.autoPlay[0] === 0 || distance.preYd !== distance.yd) {
        distance.current_x = distance.x;
        distance.x = 0;
        distance.preYd = distance.yd;
      }

      distance.play = true;

      if (distance.left && sliderListRef.current) {
        sliderListRef.current.style.transform = "translate3d(" + -distance.fullPageLast + "px, 0, 0)";
        var getNewArr = sliderListRef.current.childNodes[distance.len - 1] || {
          style: {}
        };
        getNewArr.style.left = distance.fullPageLast + "px";
        distance.left = false;
        distance.current_x = -distance.fullPageLast;
      }

      if (distance.right) {
        // @ts-ignore
        sliderListRef.current.style.transform = "translate3d(0, 0, 0)"; // @ts-ignore

        sliderListRef.current.childNodes[0].style.left = "0"; // @ts-ignore
        // sliderListRef.current.childNodes[1].style.left = `${distance.fullPageMove}px`;

        distance.current_x = 0;
        distance.right = false;
      } // 底部索引切换


      distance.index = Math.round(Math.abs(distance.current_x) / distance.fullPageMove); // @ts-ignore

      (_a = distance === null || distance === void 0 ? void 0 : distance.tempSliderProcess) === null || _a === void 0 ? void 0 : _a.setAttribute('class', 'am-carousel-wrap-dot'); // @ts-ignore

      (_d = (_c = (_b = distance === null || distance === void 0 ? void 0 : distance.sliderProcess) === null || _b === void 0 ? void 0 : _b.childNodes[0]) === null || _c === void 0 ? void 0 : _c.childNodes[distance.index]) === null || _d === void 0 ? void 0 : _d.setAttribute('class', 'am-carousel-wrap-dot am-carousel-wrap-dot-active');

      if (distance.autoPlay[0] === 1 && distance.autoPlay[1] === 1) {
        // @ts-ignore
        distance.sliderProcess.childNodes[0].childNodes[distance.index].childNodes[0].style.transform = 'scale(1, 1)';
      } // @ts-ignore


      distance.tempSliderProcess = (_f = (_e = distance === null || distance === void 0 ? void 0 : distance.sliderProcess) === null || _e === void 0 ? void 0 : _e.childNodes[0]) === null || _f === void 0 ? void 0 : _f.childNodes[distance.index];
      onChange === null || onChange === void 0 ? void 0 : onChange(distance.index);
    }
  };

  var touch = function touch(event) {
    if (!distance.play) return;

    switch (event.type) {
      case 'touchstart':
        distance.start_x = event.touches[0].clientX;
        distance.start_y = event.touches[0].clientY;
        distance.fullMove_direction = event.touches[0].clientX;
        distance.strength = new Date().getTime(); // console.log(distance.start_x, ' distance.start_x');

        if (!event.artificial) {
          distance.autoPlay[0] = 1;
        }

        break;

      case 'touchend':
        distance.play = false;
        distance.strength = new Date().getTime() - distance.strength; // eslint-disable-next-line no-case-declarations

        var distanceStr = distance.fullMove_direction - distance.mouseX;

        if (distanceStr < 0) {
          distance.targetX = -(Math.ceil(distance.x / distance.fullPageMove) * -distance.fullPageMove);
        } else {
          distance.targetX = Math.floor(distance.x / distance.fullPageMove) * distance.fullPageMove;
        } // 移动距离小于30还原当前位置


        if (Math.abs(distance.yd) < 30) {
          if (distance.left) {
            distance.left = false;
            var getDistanceArr = sliderListRef.current.childNodes[distance.len - 1];
            getDistanceArr.style.left = distance.fullPageLast + "px";
          }

          if (distance.right) {
            distance.right = false; // @ts-ignore

            sliderListRef.current.childNodes[0].style.left = "0";
          }

          distance.yd = 0;
          distance.targetX = distance.yd + distance.current_x;

          if (!event.artificial) {
            distance.autoPlay[1] = 0;
            distance.autoPlay[0] = 0;
          }
        } else {
          if (!event.artificial) {
            distance.autoPlay[1] = 1;
          }
        }

        animation(sliderListRef); // console.log('强度：' + Math.abs(distance.x) / distance.strength)

        break;

      case 'touchmove':
        if (Math.abs(event.touches[0].clientY - distance.start_y) - Math.abs(event.touches[0].clientX - distance.start_x) > 0) {
          return;
        }

        if (event.cancelable) event.preventDefault();
        distance.mouseX = event.touches[0].clientX;
        distance.x = event.touches[0].clientX - distance.start_x + distance.current_x;

        if (sliderListRef.current) {
          sliderListRef.current.style.transform = "translate3d(" + distance.x + "px, 0, 0)";
        }

        distance.yd = distance.x - distance.current_x; // console.log(event.touches[0].clientX ,distance.start_x,distance.x,'xxxx')

        if (Math.floor(-distance.x / distance.fullPageMove) === distance.len - 1 && distance.x < 0) {
          distance.right = true; // @ts-ignore

          sliderListRef.current.childNodes[0].style.left = distance.fullPageAttachMove + "px"; // @ts-ignore
          // sliderListRef.current.childNodes[1].style.left = `${distance.fullPageAttachMove +
          //   distance.fullPageMove}px`;
        }

        if (Math.floor(distance.x / distance.fullPageMove) == 0 && distance.x > 0) {
          distance.left = true; // @ts-ignore

          sliderListRef.current.childNodes[distance.len - 1].style.left = -distance.fullPageMove + "px"; // @ts-ignore
          // sliderListRef.current.childNodes[1].style.left = `${-distance.fullPageLast}px`;
        }

        break;
    }
  }; // let play = false; //是否暂停


  var i = 0; // process

  var currentLi = 0; // current process

  var time = 350; // 轮播时间

  var conLog = function conLog() {
    time = delay * 70 || time;
    if (distance.autoPlay[0] === 1 && distance.autoPlay[1] === 1) return;
    i += 1;

    if (i % time === 0) {
      i = 0; // currentLi += 1;

      currentLi = distance.index + 1;
      var _event = {
        artificial: true,
        type: 'touchstart',
        touches: [{
          clientX: 0,
          clientY: 0
        }]
      };
      touch(_event);
      _event = __assign(__assign({}, _event), {
        type: 'touchmove',
        touches: [{
          clientX: -100,
          clientY: 0
        }]
      });
      touch(_event);
      _event = __assign(__assign({}, _event), {
        type: 'touchend'
      });
      touch(_event);
    }

    autoProcess(i, currentLi % (children ? children.length : 3));
    requestFunc = requestAnimationFrame(conLog);
  };

  var autoProcess = function autoProcess(i, index) {
    var _a, _b, _c, _d;

    if ((_d = (_c = (_b = (_a = sliderProcess === null || sliderProcess === void 0 ? void 0 : sliderProcess.current) === null || _a === void 0 ? void 0 : _a.childNodes) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.childNodes) === null || _d === void 0 ? void 0 : _d[index]) {
      sliderProcess.current.childNodes[0].childNodes[index].childNodes[0].style.transform = "scale(" + (i || 0) / time + ",1)";
    }
  };

  (0, _react.useEffect)(function () {
    // const wi_w = document.documentElement.offsetWidth || document.body.offsetWidth;
    (0, _utils.windowAddEventListener)(function (status) {
      var _a, _b, _c;

      if (!status && children) {
        if (autoPlay && !distance.lockStatus) {
          conLog();
          distance.lockStatus = true;
        } // distance.index ===0  判断用户在重复操作pc和移动之间切换


        if (children && sliderListRef.current && distance.index === 0) {
          var currentRef = sliderListRef.current.childNodes[0]; // @ts-ignore

          var getWidthValue_1 = window.innerWidth || currentRef.clientWidth;
          distance.fullPageMove = getWidthValue_1;
          distance.fullPageLast = getWidthValue_1 * (sliderListRef.current.childNodes.length - 1);
          distance.fullPageAttachMove = getWidthValue_1 * sliderListRef.current.childNodes.length;
          distance.len = sliderListRef.current.childNodes.length; // currentRef.style.left = '0'; //设定第一个位置

          var setParentsHeightValue_1 = 0; // let setParentsBgtValue = '';

          sliderListRef.current.childNodes.forEach(function (item, index) {
            item.style.position = 'absolute';
            item.style.top = 0;
            item.style.width = getWidthValue_1 + "px";
            item.style.left = index * getWidthValue_1 + "px";

            if (setParentsHeightValue_1 < item.offsetHeight) {
              setParentsHeightValue_1 = item.offsetHeight;
            }

            if (accordant) {
              item.style.height = '100%';
            } // setParentsBgtValue = item.style.backgroundColor;

          }); // sliderListRef.current.style.background = setParentsBgtValue; //设置父级元素背景色

          if (accordant) {
            // @ts-ignore
            parentRef.current.style.height = String(setParentsHeightValue_1) + "px"; // 设置父级元素高度
          }

          sliderListRef.current.style.height = String(setParentsHeightValue_1) + "px"; // 设置父级元素高度

          sliderListRef.current.style.width = String(distance.fullPageAttachMove) + "px"; // 设置父级元素宽度

          sliderListRef.current.addEventListener('touchstart', touch, false);
          sliderListRef.current.addEventListener('touchmove', touch, false);
          sliderListRef.current.addEventListener('touchend', touch, false); // @ts-ignore

          distance.sliderProcess = document.querySelector("." + (indexClass || 'slider-decorator-0')); // @ts-ignore

          distance.tempSliderProcess = (_b = (_a = distance === null || distance === void 0 ? void 0 : distance.sliderProcess) === null || _a === void 0 ? void 0 : _a.childNodes[0]) === null || _b === void 0 ? void 0 : _b.childNodes[0]; // @ts-ignore

          (_c = distance.tempSliderProcess) === null || _c === void 0 ? void 0 : _c.setAttribute('class', 'am-carousel-wrap-dot am-carousel-wrap-dot-active');
        }
      } else {
        distance.lockStatus = false;

        if (requestFunc != null) {
          cancelAnimationFrame(requestFunc);
        }

        requestFunc = undefined;
      }
    }, 0);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "demoContainer",
    ref: parentRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "slider am-carousel"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "slider-frame"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    ref: sliderListRef,
    className: "slider-list"
  }, children)), render ? render() : null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: sliderProcess,
    className: indexClass || 'slider-decorator-0'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-carousel-wrap"
  }, children ? children.map(function (_item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "am-carousel-wrap-dot"
    }, /*#__PURE__*/_react["default"].createElement("span", null));
  }) : null))));
}

var _default = Carousel;
exports["default"] = _default;